import { call, options, params } from './helpers';

export const getCustomers = (payload) =>
	call(`/beta/admin/organizations${params(payload)}`);

export const getAllEvents = (payload) =>
	call(`/beta/admin/events${params(payload)}`);

export const getOrganization = (id) => {
	return call(`/beta/admin/organization/${id}`);
};
export const updateOrganization = ({ id, ...payload }) => {
	return call(`/beta/admin/organization/${id}`, options(payload, 'PUT'));
};

export const getAllTasks = (payload) =>
	call(`/beta/admin/tasks${params(payload)}`);

export const getAllAdminServiceReports = (payload) =>
	call(`/beta/admin/service-reports${params(payload)}`);

export const createBlankAdminServiceReport = (payload) =>
	call(`/beta/admin/service-reports`, options(payload, 'POST'));

export const getAdminServiceReport = ({ id }) =>
	call(`/beta/admin/service-reports/${id}`);
export const updateAdminServiceReport = ({ id, ...payload }) =>
	call(`/beta/admin/service-reports/${id}`, options(payload, 'PUT'));

export const createAdminServiceBlocks = (payload) =>
	call(`/beta/admin/service-reports/blocks`, options(payload, 'POST'));

export const updateAdminServiceBlocks = ({ id, ...payload }) =>
	call(`/beta/admin/service-reports/blocks/${id}`, options(payload, 'PUT'));

export const deleteAdminServiceBlock = ({ id }) =>
	call(`/beta/admin/service-reports/blocks/${id}`, options(null, 'DELETE'));

export const getAllAdminServiceBlocks = (payload) =>
	call(`/beta/admin/service-reports/blocks${params(payload)}`);

export const betaCreateOrganization = (payload) =>
	call(`/beta/admin/initialize`, options(payload, 'POST'));

export const getAssetsAdmin = (id) =>
	call(`/beta/admin/organization/${id}/assets`);

export const getOrganizationUsers = (id) =>
	call(`/beta/admin/organization/${id}/users`);

export const getOrganizationServiceReports = (id) =>
	call(`/beta/admin/organization/${id}/service-reports`);

export const getChildOrganizations = (id) =>
	call(`/beta/admin/organization/${id}/children`);

export const uploadServiceReportImages = ({ id, files }) =>
	call(
		`/beta/admin/service-reports/${id}/images`,
		options({ files, bucket: 'service-reports', information: {} }, 'POST'),
	);

// Admin API Tokens
export const getAdminApiTokens = (organizationId) =>
	call(`/beta/admin/organization/${organizationId}/api-tokens`);

export const createAdminApiToken = ({ organizationId, ...payload }) =>
	call(
		`/beta/admin/organization/${organizationId}/api-tokens`,
		options(payload, 'POST'),
	);

export const revokeAdminApiToken = ({ organizationId, tokenId }) =>
	call(
		`/beta/admin/organization/${organizationId}/api-tokens/${tokenId}`,
		options(null, 'DELETE'),
	);

export const getAdminApiTokenScopes = () =>
	call(`/beta/admin/api-tokens/scopes`);

export const getArchivedAssetsAdmin = (payload) =>
	call(`/beta/admin/assets/archived${params(payload)}`);

export const getExpiringContractsAdmin = (payload) =>
	call(`/beta/admin/contracts/expiring${params(payload)}`);

// Error Logs
export const getErrorLogs = (payload) =>
	call(`/beta/admin/error-logs${params(payload)}`);

export const getErrorLogsStats = (payload) =>
	call(`/beta/admin/error-logs/stats${params(payload)}`);

export const getErrorLog = (id) => call(`/beta/admin/error-logs/${id}`);

export const deleteErrorLog = (id) =>
	call(`/beta/admin/error-logs/${id}`, options(null, 'DELETE'));

export const cleanupErrorLogs = (days) =>
	call(`/beta/admin/error-logs/cleanup/${days}`, options(null, 'DELETE'));

export const bulkDeleteErrorLogs = (ids) =>
	call(`/beta/admin/error-logs/bulk-delete`, options({ ids }, 'POST'));

// Notification System (SuperAdmin)
export const getNotificationStatus = () =>
	call(`/v2/superadmin/notifications/status`);

export const toggleNotifications = (enabled) =>
	call(`/v2/superadmin/notifications/toggle`, options({ enabled }, 'PUT'));

export const getNotificationLogs = (payload) =>
	call(`/v2/superadmin/notifications/logs${params(payload)}`);

export const getScheduledNotifications = (payload) =>
	call(`/v2/superadmin/notifications/scheduled${params(payload)}`);

export const getPredictedNotifications = (payload) =>
	call(`/v2/superadmin/notifications/predicted${params(payload)}`);

export const getFailedNotifications = (payload) =>
	call(`/v2/superadmin/notifications/failed${params(payload)}`);

export const getNotificationStats = (payload) =>
	call(`/v2/superadmin/notifications/stats${params(payload)}`);

export const retryNotification = (id) =>
	call(`/v2/superadmin/notifications/retry/${id}`, options(null, 'POST'));

export const sendPredictedNotification = (payload) =>
	call(`/v2/superadmin/notifications/send-predicted`, options(payload, 'POST'));

export const previewNotificationRecipients = (payload) =>
	call(`/v2/superadmin/notifications/preview-recipients${params(payload)}`);
